interface TopicSparklineProps {
  values: number[]
  width?: number
  height?: number
  className?: string
}

export function TopicSparkline({
  values,
  width = 56,
  height = 24,
  className,
}: TopicSparklineProps) {
  if (values.length < 2) return null

  const max = Math.max(...values, 1)
  const step = width / (values.length - 1)

  const points = values
    .map((v, i) => {
      const x = i * step
      const y = height - (v / max) * height
      return `${x.toFixed(1)},${y.toFixed(1)}`
    })
    .join(' ')

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <polyline
        points={points}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-primary/60"
        fill="none"
      />
    </svg>
  )
}
